import React, { Component } from 'react'
import FaCheckSquare from "react-icons/lib/fa/check-square"
import FaSquare from 'react-icons/lib/fa/square'
import { connect } from 'react-redux'
import { getTranslate } from 'react-localize-redux';

class CustomCheckbox extends Component {
    constructor() {
        super()
        // this.state = {
        //     checked:true
        // }
    }

    // handleChange = (e) => {
    //     this.setState({
    //         checked:e.target.checked
    //     })
    //     this.props.onChange(e.target.checked)
    //    }
    render() {
        const { item, translate } = this.props

        return (
            <label className="FilterItem">
                <input
                    style={{ display: 'none' }}
                    name="smthing"
                    type="checkbox"
                    onChange={this.props.onChange.bind(this, item)}
                    checked={this.props.isChecked}
                    id={this.props.id}
                />
                <div className="checkboxIcons">
                    {this.props.isChecked ? <FaCheckSquare /> : <FaSquare />}
                    {/* {this.state.checked ? <FaCheckSquare /> :<FaSquare /> } */}
                </div>
                <p>{translate(this.props.label)}</p>
            </label>
        )
    }
}


const mapStateToProps = state => ({
    translate: getTranslate(state.locale),
})
export default connect(mapStateToProps)(CustomCheckbox)


// WEBPACK FOOTER //
// ./src/pages/SalePoints/CustomCheckbox.js